export default __webpack_public_path__ + "static/ingenieria-comercial-mobile-de23b4616cd9c63ae01e1bf744aa6dc5.svg";